import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { ApproveFundingRequestBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const approveFundingRequest = createApiThunk<void, ApproveFundingRequestBody>(
  "fundingRequests/approveFundingRequest",
  async (fundingRequest, { extra: { adminRepository } }) => {
    return adminRepository!.approve(fundingRequest);
  },
);

export const resetApproveFundingRequest = createAction("fundingRequests/resetApproveFundingRequest");
